import React, { useEffect, useState } from "react";
import UnsavedChangesAlert from "../../../ShareElements/UnsavedChangesAlert/UnsavedChangesAlert";
import axios from "axios";
import { Config } from "../../../../../../Config";
import DesktopOnlyOverlay from "../../../ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";
import Select from "../../../ShareElements/Select/Select";
import Collapsible from "react-collapsible";
import Arrow from "../../../../../../Assets/Images/Arrow-down.svg";

const Mapping = (props) => {
  const [ChangesApplied, setChangesApplied] = useState(false);
  const [UnsavedChanges, setUnsavedChanges] = useState(false);
  const [DataIsLoaded, setDataIsLoaded] = useState(false);
  const [BusinessUnits, setBusinessUnits] = useState([]);
  const [InitialBUs, setInitialBUs] = useState([]);
  const [Regions, setRegions] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [BuIsOpen, setBuIsOpen] = useState(false);
  const [RegionIsOpen, setRegionIsOpen] = useState(false);
  const [CountryIsOpen, setCountryIsOpen] = useState(false);
  const [DepartmentIsOpen, setDepartmentIsOpen] = useState(false);
  const [Departments, setDepartments] = useState([]);
  const [AddedBUList, setAddedBUList] = useState([]);
  const [AddedRegionsList, setAddedRegionsList] = useState([]);
  const [AddedCountriesList, setAddedCountriesList] = useState([]);
  const [AddedDepartmentsList, setAddedDepartmentsList] = useState([]);
  const [BUchips, setBUchips] = useState([]);
  const [RegionChips, setRegionChips] = useState([]);
  const [CountryChips, setCountryChips] = useState([]);
  const [DeptChips, setDeptChips] = useState([]);
  const [PreviousMappings, setPreviousMappings] = useState({});

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  useEffect(() => {
    try {
      // fetchBusinessUnits();
      // fetchAllRegions();
      // fetchAllCountries();
      // fetchAllDepartments();
      setDataIsLoaded(true);
    } catch (Error) {
      console.log(Error);
    }
    if (window.localStorage.getItem("MappingCreated") === "1") {
      getPreviousMappings();
    } else {
      fetchBusinessUnits();
      fetchAllRegions();
      fetchAllCountries();
      fetchAllDepartments();
    }

    return () => {
      window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    };
  }, []);

  const getPreviousMappings = () => {
    let Data = {
      criteria: {
        aclId: window.localStorage.getItem("CreatedACLId"),
      },
      size: 1000,
      start: 0,
    };
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.ACLBaseURL + "/api/restriction/search",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        // saving mapping data
        setPreviousMappings(Res.data.results[0]);
        // creating the chips
        createPrevBUchips(Res.data.results[0].businessIds);
        createPrevCountryChips(Res.data.results[0].countries);
        createPrevDeptChips(Res.data.results[0].departmentIds);
        createPrevRegChips(Res.data.results[0].regions);
        // removing previously selected items from dropdowns by passing the selected items to
        // fetch functions
        fetchBusinessUnits(Res.data.results[0].businessIds);
        fetchAllRegions(Res.data.results[0].regions);
        fetchAllCountries(Res.data.results[0].countries);
        fetchAllDepartments(Res.data.results[0].departmentIds);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const createPrevBUchips = (BUIds) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ACLBaseURL +
        "/api/location/search/business-unit",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        let Chips = [];
        let SelectedBUs = [];

        BUIds.map((BunitId) => {
          var BUnits = Res.data;
          var Filter = "id";
          var Keyword = BunitId;
          var BunitName = BUnits.filter((Obj) => {
            return Obj[Filter] === Keyword;
          });
          Chips.push(BunitName[0].name);
          SelectedBUs.push(BunitName[0]);
          AddedBUList.push({ name: BunitName[0].name, id: BunitId });
        });

        console.log(SelectedBUs, Res.data);
        setBUchips(Chips);
        console.log(AddedBUList);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const createPrevCountryChips = (Countries) => {
    let Chips = [];
    Countries.map((Country) => {
      Chips.push(Country);
      AddedCountriesList.push({ name: Country, id: Country });
    });
    setCountryChips(Chips);
  };
  const createPrevRegChips = (Regions) => {
    let Chips = [];
    Regions.map((Reg) => {
      Chips.push(Reg);
      AddedRegionsList.push({ name: Reg, id: Reg });
    });
    setRegionChips(Chips);
  };
  const createPrevDeptChips = (DepartmentIds) => {
    console.log(DepartmentIds);
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ACLBaseURL +
        "/api/location/search/department",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Chips = [];
        DepartmentIds.map((BunitId) => {
          var Departments = Res.data;
          var Filter = "id";
          var Keyword = BunitId;
          var DeptName = Departments.filter((Obj) => {
            return Obj[Filter] === Keyword;
          });
          Chips.push(DeptName[0].name);
          AddedDepartmentsList.push({
            name: DeptName[0].name,
            id: DeptName[0].id,
          });
        });
        setDeptChips(Chips);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchBusinessUnits = (PrevData) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ACLBaseURL +
        "/api/location/search/business-unit",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (PrevData) {
          let NonSelected = [];
          Res.data.map((Item) => {
            if (PrevData.indexOf(Item.id) === -1) {
              NonSelected.push(Item);
            }
          });
          setBusinessUnits(NonSelected);
        } else {
          setBusinessUnits(Res.data);
        }
        setInitialBUs(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchAllRegions = (PrevData) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ACLBaseURL +
        "/api/location/search/region",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (PrevData) {
          let NonSelected = [];
          Res.data.map((Item) => {
            if (PrevData.indexOf(Item.name) === -1) {
              NonSelected.push(Item);
            }
          });
          setRegions(NonSelected);
        } else {
          setRegions(Res.data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchAllCountries = (PrevData) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ACLBaseURL +
        "/api/location/search/country",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (PrevData) {
          let NonSelected = [];
          Res.data.map((Item) => {
            if (PrevData.indexOf(Item.name) === -1) {
              NonSelected.push(Item);
            }
          });
          setCountries(NonSelected);
        } else {
          setCountries(Res.data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchAllDepartments = (PrevData) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ACLBaseURL +
        "/api/location/search/department",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (PrevData) {
          let NonSelected = [];
          Res.data.map((Item) => {
            if (PrevData.indexOf(Item.id) === -1) {
              NonSelected.push(Item);
            }
          });
          setDepartments(NonSelected);
        } else {
          setDepartments(Res.data);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const disableSaveBtn = () => {
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
    setChangesApplied(false);
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setChangesApplied(true);
  };
  const cancelOperation = () => {
    if (ChangesApplied) {
      setUnsavedChanges(true);
    } else {
      window.localStorage.removeItem("CreatedACLId");
      window.localStorage.removeItem("MappingCreated");
      window.localStorage.removeItem("CreatedACLName");
      window.localStorage.removeItem("BasicSettingsCreated");
      window.localStorage.removeItem("HasUnsaveChanges");
      window.location.assign("/home/acls");
    }
  };
  const discardAndLeave = () => {
    setUnsavedChanges(false);
    if (window.localStorage.getItem("LastIdClicked") === "mapping") {
      window.location.assign("/home/acls");
    } else if (
      document.getElementById("bu-error").style.display !== "block" ||
      document.getElementById("reg-error").style.display !== "block" ||
      document.getElementById("country-error").style.display !== "block" ||
      document.getElementById("dept-error").style.display !== "block"
    ) {
      document
        .getElementById(window.localStorage.getItem("LastIdClicked"))
        .click();
    }
  };
  const validateEntries = () => {
    var IndexToStart;
    if (window.localStorage.getItem("MappingCreated") === "1") {
      IndexToStart = 1;
    } else {
      IndexToStart = 0;
    }
    for (let i = IndexToStart; i < parseInt(AddedBUList.length + 1); i++) {
      if (document.getElementById("select-bu-" + i + "-filter") !== null) {
        let Id = document.getElementById("select-bu-" + i + "-filter").value;
        if (Id.length === 0) {
          document
            .getElementById("select-bu-" + i + "-select")
            .classList.add("cx-select-error-shown");
          document.getElementById("bu-error").style.display = "block";
        }
      }
    }
    for (let i = IndexToStart; i < parseInt(AddedRegionsList.length + 1); i++) {
      if (document.getElementById("select-region-" + i + "-filter") !== null) {
        let Id = document.getElementById(
          "select-region-" + i + "-filter"
        ).value;
        if (Id.length === 0) {
          document
            .getElementById("select-region-" + i + "-select")
            .classList.add("cx-select-error-shown");
          document.getElementById("reg-error").style.display = "block";
        }
      }
    }
    for (
      let i = IndexToStart;
      i < parseInt(AddedCountriesList.length + 1);
      i++
    ) {
      if (document.getElementById("select-country-" + i + "-filter") !== null) {
        let Id = document.getElementById(
          "select-country-" + i + "-filter"
        ).value;
        if (Id.length === 0) {
          document
            .getElementById("select-country-" + i + "-select")
            .classList.add("cx-select-error-shown");
          document.getElementById("country-error").style.display = "block";
        }
      }
    }
    for (
      let i = IndexToStart;
      i < parseInt(AddedDepartmentsList.length + 1);
      i++
    ) {
      if (
        document.getElementById("select-department-" + i + "-filter") !== null
      ) {
        let Id = document.getElementById(
          "select-department-" + i + "-filter"
        ).value;
        if (Id.length === 0) {
          document
            .getElementById("select-department-" + i + "-select")
            .classList.add("cx-select-error-shown");
          document.getElementById("dept-error").style.display = "block";
        }
      }
    }
    if (
      document.getElementById("bu-error").style.display === "block" ||
      document.getElementById("reg-error").style.display === "block" ||
      document.getElementById("country-error").style.display === "block" ||
      document.getElementById("dept-error").style.display === "block"
    ) {
      return null;
    } else {
      createMapping();
    }
  };
  const createMapping = () => {
    let BusinessUnitsList = [];
    let RegionsList = [];
    let CountriesList = [];
    let DeptList = [];

    var IndexToStart;
    if (window.localStorage.getItem("MappingCreated") === "1") {
      IndexToStart = 1;
    } else {
      IndexToStart = 0;
    }

    for (let i = IndexToStart; i < parseInt(AddedBUList.length + 1); i++) {
      if (document.getElementById("select-bu-" + i + "-filter") !== null) {
        let Id = document.getElementById("select-bu-" + i + "-filter").value;
        BusinessUnitsList.push(Id);
      }
    }
    for (let i = IndexToStart; i < parseInt(AddedRegionsList.length + 1); i++) {
      if (document.getElementById("select-region-" + i + "-filter") !== null) {
        let Id = document.getElementById(
          "pre-selected-select-region-" + i
        ).innerHTML;
        RegionsList.push(Id);
      }
    }
    for (
      let i = IndexToStart;
      i < parseInt(AddedCountriesList.length + 1);
      i++
    ) {
      if (document.getElementById("select-country-" + i + "-filter") !== null) {
        let Id = document.getElementById(
          "pre-selected-select-country-" + i
        ).innerHTML;
        CountriesList.push(Id);
      }
    }
    for (
      let i = IndexToStart;
      i < parseInt(AddedDepartmentsList.length + 1);
      i++
    ) {
      if (
        document.getElementById("select-department-" + i + "-filter") !== null
      ) {
        let Id = document.getElementById(
          "select-department-" + i + "-filter"
        ).value;
        DeptList.push(Id);
      }
    }
    let Data = {
      acl: {
        id: window.localStorage.getItem("CreatedACLId"),
        name: window.localStorage.getItem("CreatedACLName"),
      },
      businessIds: BusinessUnitsList,
      countries: CountriesList,
      departmentIds: DeptList,
      regions: RegionsList,
    };
    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/restriction",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        window.localStorage.setItem("MappingCreated", 1); //1 : true, 0 : false
        disableSaveBtn();
        getPreviousMappings();
        document.getElementById("basic-settings").click();
        document.getElementById("mapping").click();
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const saveAndLeave = () => {
    setUnsavedChanges(false);
    for (let i = 0; i < parseInt(AddedBUList.length + 1); i++) {
      let Id = document.getElementById("select-bu-" + i + "-filter").value;
      if (Id.length === 0) {
        document
          .getElementById("select-bu-" + i + "-select")
          .classList.add("cx-select-error-shown");
        document.getElementById("bu-error").style.display = "block";
      }
    }
    for (let i = 0; i < parseInt(AddedRegionsList.length + 1); i++) {
      let Id = document.getElementById("select-region-" + i + "-filter").value;
      if (Id.length === 0) {
        document
          .getElementById("select-region-" + i + "-select")
          .classList.add("cx-select-error-shown");
        document.getElementById("reg-error").style.display = "block";
      }
    }
    for (let i = 0; i < parseInt(AddedCountriesList.length + 1); i++) {
      let Id = document.getElementById("select-country-" + i + "-filter").value;
      if (Id.length === 0) {
        document
          .getElementById("select-country-" + i + "-select")
          .classList.add("cx-select-error-shown");
        document.getElementById("country-error").style.display = "block";
      }
    }
    for (let i = 0; i < parseInt(AddedDepartmentsList.length + 1); i++) {
      let Id = document.getElementById(
        "select-department-" + i + "-filter"
      ).value;
      if (Id.length === 0) {
        document
          .getElementById("select-department-" + i + "-select")
          .classList.add("cx-select-error-shown");
        document.getElementById("dept-error").style.display = "block";
      }
    }
    if (
      document.getElementById("bu-error").style.display === "block" ||
      document.getElementById("reg-error").style.display === "block" ||
      document.getElementById("country-error").style.display === "block" ||
      document.getElementById("dept-error").style.display === "block"
    ) {
      return null;
    } else {
      let BusinessUnitsList = [];
      let RegionsList = [];
      let CountriesList = [];
      let DeptList = [];

      for (let i = 0; i < parseInt(AddedBUList.length + 1); i++) {
        let Id = document.getElementById("select-bu-" + i + "-filter").value;
        BusinessUnitsList.push(Id);
      }
      for (let i = 0; i < parseInt(AddedRegionsList.length + 1); i++) {
        let Id = document.getElementById(
          "pre-selected-select-region-" + i
        ).innerHTML;
        RegionsList.push(Id);
      }
      for (let i = 0; i < parseInt(AddedCountriesList.length + 1); i++) {
        let Id = document.getElementById(
          "pre-selected-select-country-" + i
        ).innerHTML;
        CountriesList.push(Id);
      }
      for (let i = 0; i < parseInt(AddedDepartmentsList.length + 1); i++) {
        let Id = document.getElementById(
          "select-department-" + i + "-filter"
        ).value;
        DeptList.push(Id);
      }
      let Data = {
        acl: {
          id: window.localStorage.getItem("CreatedACLId"),
          name: window.localStorage.getItem("CreatedACLName"),
        },
        businessIds: BusinessUnitsList,
        countries: CountriesList,
        departmentIds: DeptList,
        regions: RegionsList,
      };
      console.log(JSON.stringify(Data));
      let Req = {
        method: "POST",
        baseURL: window._env_.API_URL + Config.ACLBaseURL + "/api/restriction",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("Token"),
          "Content-Type": "application/json",
        },
        data: Data,
      };
      axios(Req)
        .then((Res) => {
          console.log(Res);
          window.location.assign("/home/acls");
        })
        .catch((Err) => {
          console.log(Err.response);
        });
    }
  };
  const closeAlert = () => {
    setUnsavedChanges(false);
  };
  const addOpenState = (id, ContainerId, TriggerId) => {
    document.getElementById(ContainerId).classList.remove("hidden");
    document.getElementById(id).classList.add("rotated");
    if (id === "bu-icon") {
      setBuIsOpen(true);
    } else if (id === "region-icon") {
      setRegionIsOpen(true);
    } else if (id === "country-icon") {
      setCountryIsOpen(true);
    } else if (id === "department-icon") {
      setDepartmentIsOpen(true);
    }
  };
  const removeOpenState = (id, ContainerId) => {
    document.getElementById(id).classList.remove("rotated");
    document.getElementById(ContainerId).classList.add("hidden");
    if (id === "bu-icon") {
      setBuIsOpen(false);
    } else if (id === "region-icon") {
      setRegionIsOpen(false);
    } else if (id === "country-icon") {
      setCountryIsOpen(false);
    } else if (id === "department-icon") {
      setDepartmentIsOpen(false);
    }
  };
  const closeCollapsible = (TriggerId) => {
    document.getElementById(TriggerId).click();
  };
  const addBU = () => {
    enableSave();
    AddedBUList.push({});
    setChangesApplied(!ChangesApplied);
  };
  const addRegion = () => {
    enableSave();
    AddedRegionsList.push({});
    setChangesApplied(!ChangesApplied);
  };
  const addCountry = () => {
    enableSave();
    AddedCountriesList.push({});
    setChangesApplied(!ChangesApplied);
  };
  const addDepartment = () => {
    enableSave();
    AddedDepartmentsList.push({});
    setChangesApplied(!ChangesApplied);
  };
  const addBUChips = (id) => {
    let Chips = [];
    var IndexToStart;
    if (window.localStorage.getItem("MappingCreated") === "1") {
      IndexToStart = 1;
    } else {
      IndexToStart = 0;
    }
    for (let i = IndexToStart; i < parseInt(AddedBUList.length + 1); i++) {
      if (document.getElementById("pre-selected-select-bu-" + i) !== null) {
        Chips.push(
          document.getElementById("pre-selected-select-bu-" + i).innerHTML
        );
      }
    }
    setBUchips(Chips);
  };
  const addRegionChips = (id) => {
    let Chips = [];
    if (window.localStorage.getItem("MappingCreated") === "1") {
      for (let i = 1; i < parseInt(AddedRegionsList.length + 1); i++) {
        if (
          document.getElementById("pre-selected-select-region-" + i) !== null
        ) {
          Chips.push(
            document.getElementById("pre-selected-select-region-" + i).innerHTML
          );
        }
      }
    } else {
      for (let i = 0; i < parseInt(AddedRegionsList.length + 1); i++) {
        if (
          document.getElementById("pre-selected-select-region-" + i) !== null
        ) {
          Chips.push(
            document.getElementById("pre-selected-select-region-" + i).innerHTML
          );
        }
      }
    }
    setRegionChips(Chips);
  };
  const addCountryChips = (id) => {
    let Chips = [];
    if (window.localStorage.getItem("MappingCreated") === "1") {
      for (let i = 1; i < parseInt(AddedCountriesList.length + 1); i++) {
        if (document.getElementById(id + i + "-filter") !== null) {
          Chips.push(
            document.getElementById("pre-selected-select-country-" + i)
              .innerHTML
          );
        }
      }
    } else {
      for (let i = 0; i < parseInt(AddedCountriesList.length + 1); i++) {
        if (document.getElementById(id + i + "-filter") !== null) {
          Chips.push(
            document.getElementById("pre-selected-select-country-" + i)
              .innerHTML
          );
        }
      }
    }

    setCountryChips(Chips);
  };
  const addDeptChips = (id) => {
    let Chips = [];
    if (window.localStorage.getItem("MappingCreated") === "1") {
      for (let i = 1; i < parseInt(AddedDepartmentsList.length + 1); i++) {
        Chips.push(
          document.getElementById("pre-selected-select-department-" + i)
            .innerHTML
        );
      }
    } else {
      for (let i = 0; i < parseInt(AddedDepartmentsList.length + 1); i++) {
        if (
          document.getElementById("pre-selected-select-department-" + i) !==
          null
        ) {
          Chips.push(
            document.getElementById("pre-selected-select-department-" + i)
              .innerHTML
          );
        }
      }
    }

    setDeptChips(Chips);
  };

  const removeAddedBU = (i) => {
    enableSave();
    if (
      document.getElementById("pre-selected-select-bu-" + parseInt(i + 1)) !==
        null &&
      document.getElementById("pre-selected-select-bu-" + parseInt(i + 1))
        .innerHTML !== translateText("not_specified")
    ) {
      BusinessUnits.push({
        name: document.getElementById(
          "pre-selected-select-bu-" + parseInt(i + 1)
        ).innerHTML,
        id: document.getElementById("select-bu-" + parseInt(i + 1) + "-filter")
          .value,
      });
    }
    document.getElementById("bu-error").style.display = "none";
    document.getElementById("added-bu-" + i).remove();
  };

  const removeAddedRegion = (i) => {
    enableSave();

    if (
      document.getElementById(
        "pre-selected-select-region-" + parseInt(i + 1)
      ) !== null &&
      document.getElementById("pre-selected-select-region-" + parseInt(i + 1))
        .innerHTML !== translateText("not_specified")
    ) {
      Regions.push({
        name: document.getElementById(
          "pre-selected-select-region-" + parseInt(i + 1)
        ).innerHTML,
        id: document.getElementById(
          "select-region-" + parseInt(i + 1) + "-filter"
        ).value,
      });
    }
    document.getElementById("reg-error").style.display = "none";
    document.getElementById("added-reg-" + i).remove();
  };

  const removeAddedCountry = (i) => {
    enableSave();

    if (
      document.getElementById(
        "pre-selected-select-country-" + parseInt(i + 1)
      ) !== null &&
      document.getElementById("pre-selected-select-country-" + parseInt(i + 1))
        .innerHTML !== translateText("not_specified")
    ) {
      Countries.push({
        name: document.getElementById(
          "pre-selected-select-country-" + parseInt(i + 1)
        ).innerHTML,
        id: document.getElementById(
          "select-country-" + parseInt(i + 1) + "-filter"
        ).value,
      });
    }
    document.getElementById("country-error").style.display = "none";
    document.getElementById("added-country-" + i).remove();
  };

  const removeAddedDept = (i) => {
    enableSave();

    if (
      document.getElementById(
        "pre-selected-select-department-" + parseInt(i + 1)
      ) !== null &&
      document.getElementById(
        "pre-selected-select-department-" + parseInt(i + 1)
      ).innerHTML !== translateText("not_specified")
    ) {
      Departments.push({
        name: document.getElementById(
          "pre-selected-select-department-" + parseInt(i + 1)
        ).innerHTML,
        id: document.getElementById(
          "select-department-" + parseInt(i + 1) + "-filter"
        ).value,
      });
    }
    document.getElementById("dept-error").style.display = "none";
    document.getElementById("added-dept-" + i).remove();
  };

  const updateBuList = (i) => {
    console.log(i);
    enableSave();
    document.getElementById("bu-error").style.display = "none";

    let Id = document.getElementById("select-bu-" + i + "-filter").value;

    var Filter = "id";
    var Keyword = Id;
    var BUname = BusinessUnits.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });

    setBusinessUnits(
      [...BusinessUnits].filter((Obj) => {
        return Obj !== BUname[0];
      })
    );
  };
  const updateRegList = (i) => {
    enableSave();
    document.getElementById("reg-error").style.display = "none";
    let Selected = document.getElementById(
      "select-region-" + i + "-filter"
    ).value;

    let Ids = [];
    Regions.map((Item) => {
      Ids.push(Item.id);
    });

    let IndexToRemove = Ids.indexOf(Selected);
    let PrevValues = [...Regions];
    PrevValues.splice(IndexToRemove, 1);
    setRegions(PrevValues);
  };
  const updateCountriesList = (i) => {
    enableSave();
    document.getElementById("country-error").style.display = "none";
    let Selected = document.getElementById(
      "select-country-" + i + "-filter"
    ).value;

    let Ids = [];
    Countries.map((Item) => {
      Ids.push(Item.id);
    });

    let IndexToRemove = Ids.indexOf(Selected);
    let PrevValues = [...Countries];
    PrevValues.splice(IndexToRemove, 1);
    setCountries(PrevValues);
  };
  const updateDeptList = (i) => {
    enableSave();
    document.getElementById("dept-error").style.display = "none";

    let Selected = document.getElementById(
      "select-department-" + i + "-filter"
    ).value;

    let Ids = [];
    Departments.map((Item) => {
      Ids.push(Item.id);
    });

    let IndexToRemove = Ids.indexOf(Selected);
    let PrevValues = [...Departments];
    PrevValues.splice(IndexToRemove, 1);
    setDepartments(PrevValues);
  };
  return (
    <React.Fragment>
      {DataIsLoaded ? (
        <div className="security-settings acl-edit-form">
          <DesktopOnlyOverlay LangData={props.LangData} />
          {UnsavedChanges ? (
            <UnsavedChangesAlert
              close={() => closeAlert()}
              saveAndLeave={() => saveAndLeave()}
              discardAndLeave={() => discardAndLeave()}
              LangData={props.LangData}
            />
          ) : null}
          <div className="form">
            <section className="form-header">
              <button className="return" onClick={() => cancelOperation()}>
                <i className="feather-arrow-left"></i>
              </button>
              <h1>{window.localStorage.getItem("CreatedACLName")}</h1>
              <div className="action-btn-group">
                <button onClick={() => cancelOperation()} className="cancel">
                  {translateText("cancel")}
                </button>
                <button
                  onClick={() => validateEntries()}
                  id="save-btn"
                  className="save disabled"
                >
                  {translateText("save")}
                </button>
              </div>
            </section>
            <Collapsible
              onOpening={() => addOpenState("bu-icon", "bu-list", "bu-trigger")}
              onClosing={() => removeOpenState("bu-icon", "bu-list")}
              onClose={() => addBUChips("select-bu-")}
              trigger={
                <section className="form-body trigger" id="bu-trigger">
                  <div className="form-head">
                    <h1 className="row-title">
                      {translateText("business_unit")}
                    </h1>
                    {!BuIsOpen ? (
                      <React.Fragment>
                        {BUchips.length === 0 ? null : (
                          <div className="chips-holder">
                            {BUchips.map((Item) => (
                              <React.Fragment>
                                {Item ===
                                translateText("not_specified") ? null : (
                                  <p className="chip">{Item}</p>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                      </React.Fragment>
                    ) : null}
                    <button className="trigger-btn">
                      <img id="bu-icon" className="icon" alt="" src={Arrow} />
                    </button>
                    <p id="bu-error" className="error-text">
                      {translateText("fill_unspecified_error")}.
                    </p>
                  </div>
                </section>
              }
            >
              <section className="form-body hidden" id="bu-list">
                <div className="list">
                  {AddedBUList.length === 0 ? (
                    <p> </p>
                  ) : (
                    <React.Fragment>
                      {AddedBUList.map((Item, i) => (
                        <div className="added-item" id={"added-bu-" + i}>
                          {Item.name ? (
                            <Select
                              Initial={Item.name}
                              Options={BusinessUnits}
                              IsWithId
                              Id={"select-bu-" + parseInt(i + 1)}
                              PreSelected={true}
                              PreSelectedId={Item.id}
                              NoSelectStyles={true}
                              ChangeHandler={() =>
                                updateBuList(parseInt(i + 1))
                              }
                              ValidationError={
                                translateText("specify_bu_error") + "."
                              }
                            />
                          ) : (
                            <Select
                              Initial={translateText("not_specified")}
                              Options={BusinessUnits}
                              IsWithId
                              Id={"select-bu-" + parseInt(i + 1)}
                              PreSelected={false}
                              ChangeHandler={() =>
                                updateBuList(parseInt(i + 1))
                              }
                              NoSelectStyles={true}
                              ValidationError={
                                translateText("specify_bu_error") + "."
                              }
                            />
                          )}
                          <button
                            onClick={() => removeAddedBU(parseInt(i))}
                            className="remove-btn"
                          >
                            <i className="feather-x"></i>
                          </button>
                        </div>
                      ))}
                    </React.Fragment>
                  )}
                </div>
                <div className="add">
                  <button
                    onClick={() => addBU()}
                    className="add-to-list xlarge-btn"
                    id="add-bu"
                  >
                    <i className="feather-plus"></i>
                    {translateText("add")}
                  </button>
                </div>
              </section>
            </Collapsible>
            <div className="separator"></div>
            <Collapsible
              onOpening={() =>
                addOpenState("region-icon", "reg-list", "reg-trigger")
              }
              onClosing={() => removeOpenState("region-icon", "reg-list")}
              onClose={() => addRegionChips("select-region-")}
              trigger={
                <section className="form-body trigger" id="reg-trigger">
                  <div className="form-head">
                    <h1 className="row-title">{translateText("region")}</h1>
                    {!RegionIsOpen ? (
                      <React.Fragment>
                        {RegionChips.length === 0 ? null : (
                          <div className="chips-holder">
                            {RegionChips.map((Item) => (
                              <React.Fragment>
                                {Item ===
                                translateText("not_specified") ? null : (
                                  <p className="chip">{Item}</p>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                      </React.Fragment>
                    ) : null}
                    <button className="trigger-btn">
                      <img
                        id="region-icon"
                        className="icon"
                        alt=""
                        src={Arrow}
                      />
                    </button>
                    <p id="reg-error" className="error-text">
                      {translateText("fill_unspecified_error")}.
                    </p>
                  </div>
                </section>
              }
            >
              <section className="form-body hidden" id="reg-list">
                <div className="list">
                  {AddedRegionsList.length === 0 ? null : (
                    <React.Fragment>
                      {AddedRegionsList.map((Item, i) => (
                        <div className="added-item" id={"added-reg-" + i}>
                          {Item.name ? (
                            <Select
                              Initial={Item.name}
                              Options={Regions}
                              Id={"select-region-" + parseInt(i + 1)}
                              PreSelected={true}
                              PreSelectedId={Item.id}
                              IsWithId
                              ChangeHandler={() =>
                                updateRegList(parseInt(i + 1))
                              }
                              NoSelectStyles={true}
                              ValidationError={
                                translateText("specify_reg_error") + "."
                              }
                            />
                          ) : (
                            <Select
                              Initial={translateText("not_specified")}
                              Options={Regions}
                              Id={"select-region-" + parseInt(i + 1)}
                              PreSelected={false}
                              IsWithId
                              ChangeHandler={() =>
                                updateRegList(parseInt(i + 1))
                              }
                              NoSelectStyles={true}
                              ValidationError={
                                translateText("specify_reg_error") + "."
                              }
                            />
                          )}

                          <button
                            onClick={() => removeAddedRegion(parseInt(i))}
                            className="remove-btn"
                          >
                            <i className="feather-x"></i>
                          </button>
                        </div>
                      ))}
                    </React.Fragment>
                  )}
                </div>
                <div className="add">
                  <button
                    onClick={() => addRegion()}
                    className="add-to-list xlarge-btn"
                  >
                    <i className="feather-plus"></i>
                    {translateText("add")}
                  </button>
                </div>
              </section>
            </Collapsible>
            <div className="separator"></div>
            <Collapsible
              onOpening={() => addOpenState("country-icon", "country-list")}
              onClosing={() => removeOpenState("country-icon", "country-list")}
              onClose={() => addCountryChips("select-country-")}
              trigger={
                <section className="form-body trigger">
                  <div className="form-head">
                    <h1 className="row-title">{translateText("country")}</h1>
                    {!CountryIsOpen ? (
                      <React.Fragment>
                        {CountryChips.length === 0 ? null : (
                          <div className="chips-holder">
                            {CountryChips.map((Item) => (
                              <React.Fragment>
                                {Item === translateText("not_specified") ||
                                Item.length === 0 ? null : (
                                  <p className="chip">{Item}</p>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                      </React.Fragment>
                    ) : null}
                    <button className="trigger-btn">
                      <img
                        id="country-icon"
                        className="icon"
                        alt=""
                        src={Arrow}
                      />
                    </button>
                    <p id="country-error" className="error-text">
                      {translateText("fill_unspecified_error")}.
                    </p>
                  </div>
                </section>
              }
            >
              <section className="form-body hidden" id="country-list">
                <div className="list">
                  {AddedCountriesList.length === 0 ? null : (
                    <React.Fragment>
                      {AddedCountriesList.map((Item, i) => (
                        <div
                          key={i}
                          className="added-item"
                          id={"added-country-" + i}
                        >
                          {Item.name ? (
                            <Select
                              Initial={Item.name}
                              Options={Countries}
                              IsWithId
                              NoSelectStyles={true}
                              PreSelected={true}
                              PreSelectedId={Item.id}
                              Id={"select-country-" + parseInt(i + 1)}
                              ChangeHandler={() =>
                                updateCountriesList(parseInt(i + 1))
                              }
                              ValidationError={
                                translateText("specify_country_error") + "."
                              }
                            />
                          ) : (
                            <Select
                              Initial={translateText("not_specified")}
                              NoSelectStyles={true}
                              Options={Countries}
                              Id={"select-country-" + parseInt(i + 1)}
                              PreSelected={false}
                              IsWithId
                              ChangeHandler={() =>
                                updateCountriesList(parseInt(i + 1))
                              }
                              ValidationError={
                                translateText("specify_country_error") + "."
                              }
                            />
                          )}
                          <button
                            onClick={() => removeAddedCountry(parseInt(i))}
                            className="remove-btn"
                          >
                            <i className="feather-x"></i>
                          </button>
                        </div>
                      ))}
                    </React.Fragment>
                  )}
                </div>
                <div className="add">
                  <button
                    onClick={() => addCountry()}
                    className="add-to-list xlarge-btn"
                  >
                    <i className="feather-plus"></i>
                    {translateText("add")}
                  </button>
                </div>
              </section>
            </Collapsible>
            <div className="separator"></div>
            <Collapsible
              onOpening={() => addOpenState("department-icon", "dept-list")}
              onClosing={() => removeOpenState("department-icon", "dept-list")}
              onClose={() => addDeptChips("select-department-")}
              trigger={
                <section className="form-body trigger">
                  <div className="form-head">
                    <h1 className="row-title">{translateText("department")}</h1>
                    {!DepartmentIsOpen ? (
                      <React.Fragment>
                        {DeptChips.length === 0 ? null : (
                          <div className="chips-holder">
                            {DeptChips.map((Item) => (
                              <React.Fragment>
                                {Item ===
                                translateText("not_specified") ? null : (
                                  <p className="chip">{Item}</p>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        )}
                      </React.Fragment>
                    ) : null}
                    <button className="trigger-btn">
                      <img
                        id="department-icon"
                        className="icon"
                        alt=""
                        src={Arrow}
                      />
                    </button>
                    <p id="dept-error" className="error-text">
                      {translateText("fill_unspecified_error")}.
                    </p>
                  </div>
                </section>
              }
            >
              <section className="form-body hidden" id="dept-list">
                <div className="list">
                  {AddedDepartmentsList.length === 0 ? null : (
                    <React.Fragment>
                      {AddedDepartmentsList.map((Item, i) => (
                        <div className="added-item" id={"added-dept-" + i}>
                          {Item.name ? (
                            <Select
                              Initial={Item.name}
                              Options={Departments}
                              IsWithId
                              Id={"select-department-" + parseInt(i + 1)}
                              PreSelected={true}
                              PreSelectedId={Item.id}
                              NoSelectStyles={true}
                              ChangeHandler={() => updateDeptList(i + 1)}
                              ValidationError={
                                translateText("specify_department_error") + "."
                              }
                            />
                          ) : (
                            <Select
                              Initial={translateText("not_specified")}
                              Options={Departments}
                              NoSelectStyles={true}
                              IsWithId
                              Id={"select-department-" + parseInt(i + 1)}
                              PreSelected={false}
                              ChangeHandler={() => updateDeptList(i + 1)}
                              ValidationError={
                                translateText("specify_department_error") + "."
                              }
                            />
                          )}
                          <button
                            onClick={() => removeAddedDept(parseInt(i))}
                            className="remove-btn"
                          >
                            <i className="feather-x"></i>
                          </button>
                        </div>
                      ))}
                    </React.Fragment>
                  )}
                </div>
                <div className="add">
                  <button
                    onClick={() => addDepartment()}
                    className="add-to-list xlarge-btn"
                  >
                    <i className="feather-plus"></i>
                    {translateText("add")}
                  </button>
                </div>
              </section>
            </Collapsible>
            <div className="separator"></div>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Mapping;
